import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import UploadPage from './pages/UploadPage';
import FormPage from './pages/FormPage';
import SuccessPage from './pages/SuccessPage';

function App() {
  return (
    <Router>
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Container maxWidth="lg" style={{ flex: 1, paddingTop: '2rem', paddingBottom: '2rem' }}>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/upload" element={<UploadPage />} />
              <Route path="/form/:invoiceId" element={<FormPage />} />
              <Route path="/success/:invoiceId" element={<SuccessPage />} />
            </Routes>
          </ErrorBoundary>
        </Container>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
